import _ from 'lodash';
import { Fragment, ReactElement, ReactNode } from 'react';

import { Box } from '@breathelife/mui';

import { ChildrenWrapper, FlexWrapper, Header, HorizontalLayout, VerticalLayout } from './Styles';
import { ProgressBar } from '../../../Components/ProgressBar/ProgressBar';

type BaseProps = {
  leftContent?: ReactNode;
  rightContent?: ReactNode;
  progress?: number;
  progressText?: string;
  productSummary?: ReactNode;
};

export function CenteredLayoutHeader(props: BaseProps): ReactElement {
  const ChildrenContent = (
    <ChildrenWrapper>
      {!_.isNil(props.progress) && props.progressText ? (
        <span id='progress_completed'>{props.progressText}</span>
      ) : (
        <Fragment>
          <span id='progress_completed'></span>
          <FlexWrapper />
        </Fragment>
      )}
    </ChildrenWrapper>
  );

  const productSummaryLeftContent = (
    <Box display='flex'>
      {props.leftContent}
      <Box ml={3}>{props.productSummary}</Box>
    </Box>
  );

  const desktopLeftContent = props.productSummary ? (
    productSummaryLeftContent
  ) : (
    <FlexWrapper>{props.leftContent}</FlexWrapper>
  );

  const mobileContent = (
    <Box sx={{ display: { lg: 'none', xs: 'block' } }}>
      <VerticalLayout>
        <HorizontalLayout>
          {(props.leftContent || props.rightContent) && <FlexWrapper>{props.leftContent}</FlexWrapper>}
          {(props.leftContent || props.rightContent) && <FlexWrapper>{props.rightContent}</FlexWrapper>}
        </HorizontalLayout>
        {
          <Box mx={3} mb={1}>
            {props.productSummary}
          </Box>
        }
        {!props.productSummary && ChildrenContent}
      </VerticalLayout>
    </Box>
  );

  const desktopContent = (
    <Box sx={{ display: { md: 'block', xs: 'none' } }}>
      <HorizontalLayout>
        {(props.leftContent || props.rightContent) && desktopLeftContent}
        {!props.productSummary && ChildrenContent}
        {(props.leftContent || props.rightContent) && <FlexWrapper>{props.rightContent}</FlexWrapper>}
      </HorizontalLayout>
    </Box>
  );

  return (
    <Header>
      {mobileContent}
      {desktopContent}
      <ProgressBar progress={props.progress} aria-label='progress_completed' />
    </Header>
  );
}
